'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Tables$$anon$12(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_TwoFactorAuthView$Tables$$anon$12 as $c_Lpresto_TwoFactorAuthView$Tables$$anon$12 };
$p = $c_Lpresto_TwoFactorAuthView$Tables$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Tables$$anon$12;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Tables$$anon$12() {
}
export { $h_Lpresto_TwoFactorAuthView$Tables$$anon$12 as $h_Lpresto_TwoFactorAuthView$Tables$$anon$12 };
$h_Lpresto_TwoFactorAuthView$Tables$$anon$12.prototype = $p;
$p.aL = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, $j_presto$002etypes$0024.$m_Lpresto_types$().acH(item.e1.ql), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().m);
});
var $d_Lpresto_TwoFactorAuthView$Tables$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Tables$$anon$12, "presto.TwoFactorAuthView$Tables$$anon$12", ({
  Uc: 1,
  z: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Tables$$anon$12 as $d_Lpresto_TwoFactorAuthView$Tables$$anon$12 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Tables$$anon$12.js.map
